var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          staticClass: "create_dialog",
          attrs: {
            visible: _vm.isOpen,
            "show-close": true,
            "before-close": _vm.handleClose,
            top: "20px",
            width: "70%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.isOpen = $event
            },
          },
        },
        [
          _c(
            "div",
            { staticClass: "body_dialog" },
            [
              _c(
                "el-row",
                { attrs: { type: "flex", gutter: 20 } },
                [
                  _c("el-col", { attrs: { span: 9 } }, [
                    _c("div", { staticClass: "container_info_form" }, [
                      _c(
                        "h3",
                        {
                          staticStyle: {
                            "padding-bottom": "10px",
                            "border-bottom": "2px solid #78a5e7",
                            "font-family": "system-ui",
                            color: "#000",
                          },
                        },
                        [_vm._v("\n              Thông tin phiếu")]
                      ),
                      _c("div", { staticClass: "info_content" }, [
                        _c("div", { staticClass: "element_setting" }, [
                          _c("span", { staticClass: "title_element" }, [
                            _vm._v(
                              "\n                  Mã phiếu\n                "
                            ),
                          ]),
                          _c("span", [_vm._v(":")]),
                          _c(
                            "span",
                            { staticClass: "content_element code_form" },
                            [
                              _vm._v(
                                "\n                  " +
                                  _vm._s(_vm.defaultDataForm.codeForm) +
                                  "\n                "
                              ),
                            ]
                          ),
                        ]),
                        _c("div", { staticClass: "element_setting" }, [
                          _c("span", { staticClass: "title_element" }, [
                            _vm._v(
                              "\n                  Người tạo\n                "
                            ),
                          ]),
                          _c("span", [_vm._v(":")]),
                          _c("span", { staticClass: "content_element" }, [
                            _vm._v(
                              "\n                  " +
                                _vm._s(_vm.defaultDataForm.nameUserCreate) +
                                "\n                "
                            ),
                          ]),
                        ]),
                        _c("div", { staticClass: "element_setting" }, [
                          _c("span", { staticClass: "title_element" }, [
                            _vm._v(
                              "\n                  Loại\n                "
                            ),
                          ]),
                          _c("span", [_vm._v(":")]),
                          _c("span", { staticClass: "content_element" }, [
                            _vm._v(
                              "\n                  " +
                                _vm._s(
                                  _vm.formatAppTypeCreate(
                                    _vm.defaultDataForm.appTypeCreate
                                  )
                                ) +
                                "\n                "
                            ),
                          ]),
                        ]),
                        _c("div", { staticClass: "element_setting" }, [
                          _c("span", { staticClass: "title_element" }, [
                            _vm._v(
                              "\n                  Thời gian áp dụng\n                "
                            ),
                          ]),
                          _c("span", [_vm._v(":")]),
                          _vm.defaultDataForm.fistDay &&
                          _vm.defaultDataForm.lastDay
                            ? _c("span", { staticClass: "content_element" }, [
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(
                                      _vm._f("formatDate")(
                                        _vm.defaultDataForm.fistDay
                                      )
                                    ) +
                                    " đến " +
                                    _vm._s(
                                      _vm._f("formatDate")(
                                        _vm.defaultDataForm.lastDay
                                      )
                                    ) +
                                    "\n                "
                                ),
                              ])
                            : _c("span", { staticClass: "content_element" }, [
                                _vm._v(
                                  "\n                  Không\n                "
                                ),
                              ]),
                        ]),
                        _c("div", { staticClass: "element_setting" }, [
                          _c("span", { staticClass: "title_element" }, [
                            _vm._v(
                              "\n                  Trả lời ẩn danh\n                "
                            ),
                          ]),
                          _c("span", [_vm._v(":")]),
                          _c("span", { staticClass: "content_element" }, [
                            _vm._v(
                              "\n                  " +
                                _vm._s(
                                  _vm.defaultDataForm.anonymous ? "Có" : "Không"
                                ) +
                                "\n                "
                            ),
                          ]),
                        ]),
                        _c("div", { staticClass: "element_setting" }, [
                          _c("span", { staticClass: "title_element" }, [
                            _vm._v(
                              "\n                  Sửa câu trả lời\n                "
                            ),
                          ]),
                          _c("span", [_vm._v(":")]),
                          _c("span", { staticClass: "content_element" }, [
                            _vm._v(
                              "\n                  " +
                                _vm._s(
                                  _vm.defaultDataForm.fix ? "Có" : "Không"
                                ) +
                                "\n                "
                            ),
                          ]),
                        ]),
                        _c("hr"),
                        _c("div", { staticClass: "element_setting" }, [
                          _c("span", { staticClass: "title_element" }, [
                            _vm._v(
                              "\n                  Lượt truy cập\n                "
                            ),
                          ]),
                          _c("span", [_vm._v(":")]),
                          _c("span", { staticClass: "content_element" }, [
                            _vm._v(
                              "\n                  " +
                                _vm._s(_vm.defaultDataForm.visit) +
                                "\n                "
                            ),
                          ]),
                        ]),
                        _c("div", { staticClass: "element_setting" }, [
                          _c("span", { staticClass: "title_element" }, [
                            _vm._v(
                              "\n                  Lượt xem\n                "
                            ),
                          ]),
                          _c("span", [_vm._v(":")]),
                          _c("span", { staticClass: "content_element" }, [
                            _vm._v(
                              "\n                  " +
                                _vm._s(_vm.defaultDataForm.viewers) +
                                "\n                "
                            ),
                          ]),
                        ]),
                      ]),
                    ]),
                    _c("div", { staticClass: "container_apply" }, [
                      _c(
                        "h3",
                        {
                          staticStyle: {
                            "padding-bottom": "10px",
                            "border-bottom": "2px solid rgb(120, 165, 231)",
                            "font-family": "system-ui",
                            color: "#000",
                          },
                        },
                        [
                          _vm._v(
                            "\n              Thông tin người trả lời\n            "
                          ),
                        ]
                      ),
                      _c("div", { staticClass: "info_content" }, [
                        _c("div", { staticClass: "element_setting" }, [
                          _c("span", { staticClass: "title_element" }, [
                            _vm._v("\n                  Mã\n                "),
                          ]),
                          _c("span", [_vm._v(":")]),
                          _c("span", { staticClass: "content_element" }, [
                            _vm._v(
                              "\n                  " +
                                _vm._s(
                                  _vm.typeUser === "kids"
                                    ? _vm.infoAnswerKid.code
                                    : _vm.infoAnswerTeacher.icode
                                ) +
                                "\n                "
                            ),
                          ]),
                        ]),
                        _c("div", { staticClass: "element_setting" }, [
                          _c("span", { staticClass: "title_element" }, [
                            _vm._v(
                              "\n                  Họ và tên\n                "
                            ),
                          ]),
                          _c("span", [_vm._v(":")]),
                          _c("span", { staticClass: "content_element" }, [
                            _vm._v(
                              "\n                  " +
                                _vm._s(
                                  _vm.typeUser === "kids"
                                    ? _vm.infoAnswerKid.name
                                    : _vm.infoAnswerTeacher.fullName
                                ) +
                                "\n                "
                            ),
                          ]),
                        ]),
                        _c("div", { staticClass: "element_setting" }, [
                          _c("span", { staticClass: "title_element" }, [
                            _vm._v(
                              "\n                  Nhân sự / Học sinh\n                "
                            ),
                          ]),
                          _c("span", [_vm._v(":")]),
                          _c("span", { staticClass: "content_element" }, [
                            _vm._v(
                              "\n                  " +
                                _vm._s(_vm.formatAppTypeAnswer(_vm.typeUser)) +
                                "\n                "
                            ),
                          ]),
                        ]),
                        _c("div", { staticClass: "element_setting" }, [
                          _c("span", { staticClass: "title_element" }, [
                            _vm._v("\n                  SĐT\n                "),
                          ]),
                          _c("span", [_vm._v(":")]),
                          _c("span", { staticClass: "content_element" }, [
                            _vm._v(
                              "\n                  " +
                                _vm._s(
                                  _vm.typeUser === "kids"
                                    ? _vm.infoAnswerKid.phone
                                    : _vm.infoAnswerTeacher.phone
                                ) +
                                "\n                "
                            ),
                          ]),
                        ]),
                        _c("div", { staticClass: "element_setting" }, [
                          _c("span", { staticClass: "title_element" }, [
                            _vm._v(
                              "\n                  Ngày trả lời\n                "
                            ),
                          ]),
                          _c("span", [_vm._v(":")]),
                          _c("span", { staticClass: "content_element" }, [
                            _vm._v(
                              "\n                  " +
                                _vm._s(
                                  _vm.typeUser === "kids"
                                    ? _vm.infoAnswerKid.dateSeenAnswer
                                    : _vm.infoAnswerTeacher.dateSeenAnswer
                                ) +
                                "\n                "
                            ),
                          ]),
                        ]),
                      ]),
                    ]),
                  ]),
                  _c("el-col", { attrs: { span: 15 } }, [
                    _c(
                      "div",
                      {
                        staticStyle: {
                          border: "1px solid #bfbfbf",
                          "border-radius": "10px",
                          padding: "20px 0",
                          height: "610px",
                          overflow: "auto",
                        },
                      },
                      [
                        _c(
                          "div",
                          {
                            staticStyle: {
                              display: "flex",
                              "justify-content": "center",
                            },
                          },
                          [
                            _c("div", { staticClass: "survey_form" }, [
                              _c(
                                "section",
                                {
                                  staticClass: "wrap_image_form radius border",
                                },
                                [
                                  _c("el-image", {
                                    staticClass: "main_image",
                                    attrs: { src: _vm.defaultDataForm.imgWeb },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "section",
                                {
                                  staticClass:
                                    "header_survey_form radius border element_form",
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "header_survey_title" },
                                    [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(_vm.defaultDataForm.title)
                                        ),
                                      ]),
                                    ]
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "header_survey_description",
                                    },
                                    [
                                      _vm._v(
                                        "\n                    " +
                                          _vm._s(
                                            _vm.defaultDataForm.description
                                          ) +
                                          "\n                  "
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                              _c(
                                "section",
                                {
                                  ref: "wrapQuestion",
                                  staticClass: "wrap_question",
                                },
                                _vm._l(
                                  _vm.defaultDataForm
                                    .questionAndAnswerResponseList,
                                  function (question, index) {
                                    return _c(
                                      "div",
                                      {
                                        key: index,
                                        ref: `elementForm-${index}`,
                                        refInFor: true,
                                        staticClass:
                                          "radius border element_form",
                                        on: {
                                          click: function ($event) {
                                            return _vm.handleElementClick(index)
                                          },
                                        },
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "element_body" },
                                          [
                                            _c(
                                              "el-row",
                                              {
                                                attrs: {
                                                  type: "flex",
                                                  gutter: 14,
                                                },
                                              },
                                              [
                                                _c(
                                                  "el-col",
                                                  { attrs: { span: 24 } },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "element_question",
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "question_title",
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                              " +
                                                                _vm._s(
                                                                  question
                                                                    .questionResponse
                                                                    .questionText
                                                                ) +
                                                                "\n                              "
                                                            ),
                                                            question
                                                              .questionResponse
                                                              .obligatory
                                                              ? _c(
                                                                  "span",
                                                                  {
                                                                    staticStyle:
                                                                      {
                                                                        color:
                                                                          "red",
                                                                      },
                                                                  },
                                                                  [_vm._v("*")]
                                                                )
                                                              : _vm._e(),
                                                          ]
                                                        ),
                                                        question
                                                          .questionResponse
                                                          .typeQuestion ===
                                                        "Text"
                                                          ? _c(
                                                              "div",
                                                              {
                                                                staticStyle: {
                                                                  "padding-left":
                                                                    "16px",
                                                                },
                                                              },
                                                              [
                                                                _c(
                                                                  "span",
                                                                  {
                                                                    staticStyle:
                                                                      {
                                                                        "white-space":
                                                                          "pre-line",
                                                                      },
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        question
                                                                          .answerResponse
                                                                          .answerText
                                                                      )
                                                                    ),
                                                                  ]
                                                                ),
                                                              ]
                                                            )
                                                          : _vm._e(),
                                                        question
                                                          .questionResponse
                                                          .typeQuestion ===
                                                        "CheckBox"
                                                          ? _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "wrap_checkbox element_answer",
                                                              },
                                                              _vm._l(
                                                                question
                                                                  .questionResponse
                                                                  .valueQuestionArray,
                                                                function (
                                                                  item,
                                                                  indexOption
                                                                ) {
                                                                  return _c(
                                                                    "el-checkbox",
                                                                    {
                                                                      key: indexOption,
                                                                      staticClass:
                                                                        "container_checkbox",
                                                                      attrs: {
                                                                        disabled: true,
                                                                        checked:
                                                                          _vm
                                                                            .formatAnswer(
                                                                              question
                                                                                .answerResponse
                                                                                .answerText
                                                                            )
                                                                            .includes(
                                                                              _vm.normalizeKey(
                                                                                item.value
                                                                              )
                                                                            ),
                                                                        label:
                                                                          item.value,
                                                                      },
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "div",
                                                                        {
                                                                          staticStyle:
                                                                            {
                                                                              color:
                                                                                "#000",
                                                                            },
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            "\n                                  " +
                                                                              _vm._s(
                                                                                item.value
                                                                              ) +
                                                                              "\n                                "
                                                                          ),
                                                                        ]
                                                                      ),
                                                                    ]
                                                                  )
                                                                }
                                                              ),
                                                              1
                                                            )
                                                          : _vm._e(),
                                                        question
                                                          .questionResponse
                                                          .typeQuestion ===
                                                        "Radio"
                                                          ? _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "wrap_checkbox element_answer",
                                                              },
                                                              _vm._l(
                                                                question
                                                                  .questionResponse
                                                                  .valueQuestionArray,
                                                                function (
                                                                  item,
                                                                  index
                                                                ) {
                                                                  return _c(
                                                                    "el-radio",
                                                                    _vm._b(
                                                                      {
                                                                        key: index,
                                                                        staticClass:
                                                                          "container_checkbox",
                                                                        attrs: {
                                                                          disabled: true,
                                                                        },
                                                                      },
                                                                      "el-radio",
                                                                      _vm
                                                                        .formatAnswer(
                                                                          question
                                                                            .answerResponse
                                                                            .answerText
                                                                        )
                                                                        .includes(
                                                                          _vm.normalizeKey(
                                                                            item.value
                                                                          )
                                                                        )
                                                                        ? {}
                                                                        : {
                                                                            label:
                                                                              item.value,
                                                                          },
                                                                      false
                                                                    ),
                                                                    [
                                                                      _c(
                                                                        "div",
                                                                        {
                                                                          staticStyle:
                                                                            {
                                                                              display:
                                                                                "inline-block",
                                                                              color:
                                                                                "#000",
                                                                            },
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            "\n                                  " +
                                                                              _vm._s(
                                                                                item.value
                                                                              ) +
                                                                              "\n                                "
                                                                          ),
                                                                        ]
                                                                      ),
                                                                    ]
                                                                  )
                                                                }
                                                              ),
                                                              1
                                                            )
                                                          : _vm._e(),
                                                        question
                                                          .questionResponse
                                                          .typeQuestion ===
                                                        "Point"
                                                          ? _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "element_answer",
                                                              },
                                                              [
                                                                _c(
                                                                  "div",
                                                                  {
                                                                    staticStyle:
                                                                      {
                                                                        display:
                                                                          "flex",
                                                                        gap: "0 12px",
                                                                      },
                                                                  },
                                                                  _vm._l(
                                                                    10,
                                                                    function (
                                                                      item,
                                                                      index
                                                                    ) {
                                                                      return _c(
                                                                        "div",
                                                                        {
                                                                          key: index,
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "span",
                                                                            {
                                                                              class:
                                                                                parseInt(
                                                                                  question
                                                                                    .answerResponse
                                                                                    .answerText
                                                                                ) ===
                                                                                index +
                                                                                  1
                                                                                  ? "option_point choice_point"
                                                                                  : "option_point",
                                                                            },
                                                                            [
                                                                              _vm._v(
                                                                                "\n                                    " +
                                                                                  _vm._s(
                                                                                    item
                                                                                  ) +
                                                                                  "\n                                  "
                                                                              ),
                                                                            ]
                                                                          ),
                                                                        ]
                                                                      )
                                                                    }
                                                                  ),
                                                                  0
                                                                ),
                                                              ]
                                                            )
                                                          : _vm._e(),
                                                        question
                                                          .questionResponse
                                                          .typeQuestion ===
                                                        "Star"
                                                          ? _c("div", [
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "element_answer",
                                                                  staticStyle: {
                                                                    display:
                                                                      "flex",
                                                                    gap: "0 10px",
                                                                  },
                                                                },
                                                                _vm._l(
                                                                  5,
                                                                  function (
                                                                    item
                                                                  ) {
                                                                    return _c(
                                                                      "span",
                                                                      {
                                                                        key: item,
                                                                        class:
                                                                          parseInt(
                                                                            question
                                                                              .answerResponse
                                                                              .answerText
                                                                          ) >=
                                                                          item
                                                                            ? "icon_star choice_star"
                                                                            : "icon_star disable_star",
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "i",
                                                                          {
                                                                            staticClass:
                                                                              "el-icon-star-on",
                                                                          }
                                                                        ),
                                                                      ]
                                                                    )
                                                                  }
                                                                ),
                                                                0
                                                              ),
                                                            ])
                                                          : _vm._e(),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                      ]
                                    )
                                  }
                                ),
                                0
                              ),
                            ]),
                          ]
                        ),
                      ]
                    ),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _c("div", { attrs: { slot: "footer" }, slot: "footer" }, [
            _c(
              "div",
              { staticStyle: { padding: "10px 0" } },
              [
                _c(
                  "el-button",
                  { attrs: { type: "danger" }, on: { click: _vm.handleClose } },
                  [
                    _c("i", { staticClass: "el-icon-circle-close" }),
                    _vm._v("\n          Đóng\n        "),
                  ]
                ),
              ],
              1
            ),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }